import script from "./AllCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./AllCourses.vue?vue&type=script&setup=true&lang=js"

import "./AllCourses.vue?vue&type=style&index=0&id=16211671&scope=true&lang=css"

const __exports__ = script;

export default __exports__